export enum BrochureLinks {
    Dental = "https://www.paperturn-view.com/esschem-europe/esschem-brochure-1?pid=ODg8848999",
    Cosmetic = "https://www.paperturn-view.com/esschem-europe/esschem-cosmetic-brochure-2?pid=ODg8849000"
}